import type { FilterState } from './types';

/**
 * All views available in the application.
 */
export type ViewType = 'inventory' | 'security' | 'metrics' | 'relationships' | 'dashboard';

/**
 * Given a FilterState and a target view, returns the correct subset of filters
 * to carry over based on view-specific persistence rules:
 *
 * - `providers`, `regions`, `projectsOrAccounts` persist in ALL views
 * - `severities` persist ONLY in `inventory` and `security` views
 * - `resourceTypes` persist in all views EXCEPT `metrics`
 * - `search` is always cleared when navigating between views
 */
export function persistFiltersForView(filters: FilterState, targetView: ViewType): FilterState {
  const severityViews: ViewType[] = ['inventory', 'security'];

  return {
    providers: [...filters.providers],
    regions: [...filters.regions],
    projectsOrAccounts: [...filters.projectsOrAccounts],
    environments: [...filters.environments],
    resourceTypes: targetView === 'metrics' ? [] : [...filters.resourceTypes],
    severities: severityViews.includes(targetView) ? [...filters.severities] : [],
    search: '',
  };
}
